module.exports = __webpack_public_path__ + "static/media/red_bottle.a2b8d956.png";